import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { MARKETING_FILTER_QUERY } from "graphql/marketingFilter";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let marketingFilterClient = null;

const getMarketingFilterClient = () => {
  if (marketingFilterClient) {
    return marketingFilterClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  marketingFilterClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return marketingFilterClient;
};

export async function fetchMarketingFilter() {
  try {
    const client = getMarketingFilterClient();

    const { data } = await client.query({
      query: MARKETING_FILTER_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Marketing Filter GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Marketing Filter GraphQL error:", error);
    throw error;
  }
}


